// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desc-cont .short-text {
  display: none;
}
.desc-cont .long-text {
  display: inline-block;
}
.desc-cont.shorter-text .short-text {
  display: inline-block;
}
.desc-cont.shorter-text .long-text {
  display: none;
}
.desc-cont .toggle-text {
  margin-left: 5px;
  font-style: italic;
}
.desc-cont .toggle-text.read-more {
  margin-left: 17px;
  position: relative;
}
.desc-cont .toggle-text.read-more::after {
  content: "...";
  position: absolute;
  left: -14px;
  top: 0;
  width: 21px;
  height: 5px;
}
.desc-cont .toggle-text.long-text {
  margin-left: 5px;
}
.desc-cont .toggle-text:hover {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
